// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3UfPt","question":"styles_question__3ZEQ2","description":"styles_description__3aa4R"};